export enum Environment {
  LOCAL = "LOCAL",
  DEVELOPMENT = "DEVELOPMENT",
  UAT = "UAT",
  PRODUCTION = "PRODUCTION",
}
